import * as React from 'react';
import styled from 'styled-components';
import * as Blocks from './blocks';
import { LandingPageProvider } from '@ids/context';
import OverwhelmedForm from '@ids/components/OverwhelmedForm';
import { useOverwhelmedOverlayState } from '@ids/context/OverwhelmedOverlay';
import { sendBrazeCustomEvent, TRACKING_IDS_PAGE_LABELS, useFeatureToggle } from '@ids/appshell';
import usePageViewTracking from '@ids/hooks/usePageViewTracking';
import useFocusableSections from '@ids/hooks/useFocusableSections';

const StyledLandingPageLayout = styled.div`
    position: relative;
`;

const Landing = React.memo(() => {
    const { p100StudioNewHero } = useFeatureToggle();

    return (
        <LandingPageProvider>
            <StyledLandingPageLayout data-testid="ids-landing-page">
                {p100StudioNewHero ? <Blocks.Hero /> : <Blocks.OldHero />}
                <Blocks.OurProjects />
                <Blocks.ProjectSlider />
                <Blocks.HowItWorks />
                <Blocks.WhatYouGet />
                <Blocks.Reviews />
                <Blocks.FAQ />
                <Blocks.Press />
            </StyledLandingPageLayout>
        </LandingPageProvider>
    );
});
Landing.displayName = 'Landing';

const LandingPage = () => {
    usePageViewTracking(TRACKING_IDS_PAGE_LABELS.LANDING);
    useFocusableSections();

    const { isOverwhelmedOverlayOpen } = useOverwhelmedOverlayState();

    React.useEffect(() => {
        sendBrazeCustomEvent({ name: 'WestwingStudioView' });
    }, []);

    return (
        <React.Fragment>
            <Landing />
            {isOverwhelmedOverlayOpen && <OverwhelmedForm />}
        </React.Fragment>
    );
};

export default LandingPage;
